"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { MapPin } from "lucide-react";
export default function GoogleMapSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className="py-16 px-4 sm:px-6 lg:px-8 bg-light-background">
      <div className="max-w-7xl mx-auto">
        <div className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center gap-2 mb-4">
              <MapPin className="size-8 text-primary-700" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground-light mb-4">
              Visit Our Office
            </h2>
            <p className="text-lg text-foreground-body max-w-2xl mx-auto">
              Find us conveniently located in Universal City, Texas. We look
              forward to welcoming you and your family.
            </p>
          </div>

          <Card className="overflow-hidden shadow-medium hover:shadow-strong transition-all duration-300 bg-background-card">
            <div className="relative w-full h-[450px] sm:h-[500px] lg:h-[600px]">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3473.2!2d-98.2956!3d29.5483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c8f9a9a9a9a9a%3A0x9a9a9a9a9a9a9a9a!2s916%20Coronado%20Blvd%2C%20Universal%20City%2C%20TX%2078148!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Alpha Dental Location Map" className="w-full h-full" />
            </div>

            <div className="p-6 sm:p-8 bg-background-card">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <h3 className="text-xl font-semibold text-foreground-light mb-2">
                    Alpha Dental
                  </h3>
                  <p className="text-foreground-body">
                    916 Coronado Blvd
                    <br />
                    Universal City, TX 78148
                  </p>
                </div>
                <div className="flex flex-col gap-3">
                  <Link to="https://maps.app.goo.gl/LK1y8QJAMZd91iWG7" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-foreground-primary rounded-md font-semibold shadow-soft hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-200">
                    <MapPin className="size-4" />
                    Get Directions
                  </Link>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}